import { render } from "./ReturnItem.vue?vue&type=template&id=4edfb260&scoped=true"
import script from "./ReturnItem.vue?vue&type=script&lang=js"
export * from "./ReturnItem.vue?vue&type=script&lang=js"

import "./ReturnItem.vue?vue&type=style&index=0&id=4edfb260&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edfb260"]])

export default __exports__